/*
 * OctaMirror V9: shared size selection + first screen, Take it apart, wall and buy bar.
 *
 * Selection contract (consumed by the V9 sections of both build agents):
 *   - every change (and initial load) dispatches `casa:octa-v9:size` on document with
 *     { variantId, sizeKey: 's'|'m'|'l', price, compareAt, available }, sets
 *     html[data-octa-v9-size] and window.casa.octaV9.current.
 *   - any section requests a change with
 *     document.dispatchEvent(new CustomEvent('casa:octa-v9:select', { detail: { variantId } })).
 *   - the change is written to the NATIVE variant picker immediately (radio.checked + a bubbling
 *     'change'; never debounced, never .click()), so the product form, cart drawer, free-gift shim,
 *     EDD app and analytics keep their single source of truth. Non-native ADD TO CART buttons wait
 *     until the native form carries the chosen id and its button is enabled, then click it.
 */
(function () {
  'use strict';
  window.casa = window.casa || {};
  if (window.casa.octaV9 && window.casa.octaV9.ready) return;
  var api = (window.casa.octaV9 = window.casa.octaV9 || {});
  api.ready = true;

  var doc = document;
  var root = doc.documentElement;
  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var variants = [];

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function byId(id) {
    for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
    return null;
  }
  function byKey(key) {
    for (var i = 0; i < variants.length; i++) if (variants[i].key === key) return variants[i];
    return null;
  }

  /* ---------------- selection ---------------- */
  function nativeRadio(id) { return $('[data-ov9-main] variant-picker input[type="radio"][data-variant-id="' + id + '"]'); }
  function nativeForm() { return $('[data-ov9-main] product-form-component form'); }
  function nativeButton() { return $('[data-ov9-main] product-form-component [ref="addToCartButton"]'); }

  function driveNative(id) {
    var r = nativeRadio(id);
    if (r && !r.checked) {
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function paintPickers(id) {
    $$('[data-ov9-pick]').forEach(function (b) {
      var on = String(b.getAttribute('data-variant-id')) === String(id);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
  }

  // Price inside Add to cart (owner Oct 9, option A + S1): one line when the widest of the three sizes
  // fits, else label over prices (html.ov9-atc-stack). The state lives on <html> because Horizon morphs
  // the form after a size change and would strip a class set inside it. Measured with inline styles only
  // (no nodes added), so the form's childList observer below never re-triggers itself.
  var fitRaf = 0;
  function fitAtc() {
    var btn = nativeButton();
    var a = btn && btn.querySelector('.ov9-atc');
    if (!a) return;
    root.classList.remove('ov9-atc-stack');
    var cs = getComputedStyle(btn);
    var avail = btn.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var label = a.querySelector('.ov9-atc__label');
    var sep = a.querySelector('.ov9-atc__sep');
    var gap = parseFloat(getComputedStyle(a).columnGap) || 0;
    var widest = 0;
    $$('.ov9-atc__price', a).forEach(function (p) {
      p.style.setProperty('display', 'inline-flex', 'important');
      widest = Math.max(widest, p.getBoundingClientRect().width);
      p.style.removeProperty('display');
    });
    var need = (label ? label.getBoundingClientRect().width : 0) + (sep ? sep.getBoundingClientRect().width : 0) + gap * 2 + widest;
    if (need > avail + 0.5) root.classList.add('ov9-atc-stack');
  }
  function scheduleFitAtc() {
    if (fitRaf) return;
    fitRaf = requestAnimationFrame(function () { fitRaf = 0; fitAtc(); });
  }
  window.addEventListener('resize', scheduleFitAtc, { passive: true });
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(scheduleFitAtc);

  // Screen readers hear the selected size's price with the button ("ADD TO CART, $299.99");
  // the visible label stays "ADD TO CART". Price text comes from the server-rendered price row.
  // When the button shows the price itself (.ov9-atc), the hidden copy would be read twice, so it goes.
  function paintButtonPrice(key) {
    var btn = nativeButton();
    var now = $('[data-ov9-main] .ov9-price__row[data-ov9-for="' + key + '"] .ov9-price__now');
    if (!btn || !now) return;
    var sr = btn.querySelector('.ov9-atc-price');
    if (btn.querySelector('.ov9-atc')) {
      if (sr) sr.remove();
      fitAtc();
    } else {
      if (!sr) {
        sr = doc.createElement('span');
        sr.className = 'ov9-atc-price visually-hidden';
        btn.appendChild(sr);
      }
      var text = ', ' + now.textContent.trim();
      if (sr.textContent !== text) sr.textContent = text;
    }
    // Horizon re-renders the form after a variant change; put the price back (or refit) when it does.
    var form = btn.closest('product-form-component');
    if (form && !form.__ov9PriceWatch && window.MutationObserver) {
      form.__ov9PriceWatch = new MutationObserver(function () {
        if (api.current) paintButtonPrice(api.current.sizeKey);
      });
      form.__ov9PriceWatch.observe(form, { childList: true, subtree: true });
    }
  }

  function select(id, opts) {
    var v = byId(id);
    if (!v) return;
    opts = opts || {};
    var changed = !api.current || String(api.current.variantId) !== String(v.id);
    api.current = { variantId: v.id, sizeKey: v.key, price: v.price, compareAt: v.compareAt, available: v.available };
    root.dataset.octaV9Size = v.key;
    paintPickers(v.id);
    paintButtonPrice(v.key);
    // Installments forms follow the selected size (Shop Pay reads the form's variant id).
    $$('input[data-ov9-terms-id]').forEach(function (inp) {
      if (String(inp.value) !== String(v.id)) {
        inp.value = v.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    if (!opts.fromNative) driveNative(v.id);
    // Horizon greys the button until it has refetched the whole page (1-2 s on broadband, longer on
    // phones). The size cards already know the variant: give the form its id and re-enable now;
    // Horizon's own update lands later with the same values.
    var form = nativeForm();
    var idInput = form && form.querySelector('input[name="id"]');
    var nb = nativeButton();
    if (idInput) idInput.value = v.id;
    if (nb && v.available) nb.disabled = false;
    if (changed || opts.force) {
      doc.dispatchEvent(new CustomEvent('casa:octa-v9:size', { detail: api.current }));
      wallDraw();
      paintAvailability();
    }
  }
  api.select = function (id) { select(id); };

  function say(msg) {
    var live = $('[data-ov9-live]');
    if (!live) {
      live = doc.createElement('div');
      live.setAttribute('data-ov9-live', '');
      live.setAttribute('role', 'status');
      live.className = 'visually-hidden';
      doc.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  function addToCart(btn) {
    if (!api.current || btn.getAttribute('aria-busy') === 'true') return;
    if (!api.current.available || btn.getAttribute('aria-disabled') === 'true') return;
    var id = api.current.variantId;
    driveNative(id);
    btn.setAttribute('aria-busy', 'true');
    var start = Date.now();
    var retried = false;
    (function tick() {
      var form = nativeForm();
      var input = form && form.querySelector('input[name="id"]');
      var nb = nativeButton();
      var ready = input && String(input.value) === String(id) && nb && !nb.disabled;
      if (ready) {
        btn.removeAttribute('aria-busy');
        nb.click();
        return;
      }
      if (!retried && Date.now() - start > 4000) {
        /* The native picker's fetch failed or was aborted: the radio is checked but the form
           never received the id. Re-announce the change once so Horizon refetches. */
        retried = true;
        var r = nativeRadio(id);
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (Date.now() - start > 9000) {
        btn.removeAttribute('aria-busy');
        say(btn.getAttribute('data-error') || 'Could not add to cart. Please try again.');
        return;
      }
      setTimeout(tick, 60);
    })();
  }

  function paintAvailability() {
    if (!api.current) return;
    var sold = !api.current.available;
    $$('[data-ov9-atc]').forEach(function (b) {
      // A button that shows its price (.ov9-atc, phone bar) keeps that markup: only the label span changes.
      var t = b.querySelector('.ov9-atc__label') || b;
      if (!b.hasAttribute('data-label')) b.setAttribute('data-label', t.textContent.trim());
      var text = sold ? b.getAttribute('data-soldout') || 'SOLD OUT' : b.getAttribute('data-label');
      if (sold) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
      if (t.textContent !== text) t.textContent = text;
    });
    fitPill();
  }

  /* ---------------- first screen: lights + gallery + EDD ---------------- */
  function initMain(main) {
    if (!main || main.dataset.ov9Init) return;
    main.dataset.ov9Init = '1';
    // No lights switch (Elie, Oct 10: "remove on/off functional;ity on the v9 top of the page") and the page is
    // always light (Elie, Oct 11: "keep it light color always not dark"). The section renders data-lights="off"
    // and sets html[data-ov9-page="off"] inline; lower sections key their light colours off that attribute.
    // Set again here in case the inline script was skipped.
    document.documentElement.setAttribute('data-ov9-page', 'off');

    var gallery = $('[data-ov9-gallery]', main);
    var track = gallery && $('[data-ov9-track]', gallery);
    if (track) {
      var count = $('[data-ov9-count]', gallery);
      var thumbs = $$('[data-ov9-thumb]', gallery);
      var navs = $$('[data-ov9-nav]', gallery);
      var slides = $$('[data-ov9-slide]', track);
      var slideCount = slides.length;
      // Slide an arrow is scrolling to, so quick repeat taps add up. Trusted for 700 ms only: an
      // interrupted or never-finished scroll must not leave the arrows stuck on a stale target.
      var navTarget = null;
      var navAt = 0;
      // The desktop strip and proof are visible with the hero. Promote their
      // small images so the first view never presents empty squares or logos.
      var desktopThumbs = window.matchMedia && window.matchMedia('(min-width: 990px)');
      var loadDesktopThumbs = function () {
        if (!desktopThumbs || !desktopThumbs.matches) return;
        thumbs.forEach(function (thumb) {
          var img = $('img', thumb);
          if (img) img.loading = 'eager';
        });
        $$('.ov9-assure__review img, .ov9-assure__venues-list img', main).forEach(function (img) {
          img.loading = 'eager';
        });
      };
      loadDesktopThumbs();
      if (desktopThumbs && desktopThumbs.addEventListener) desktopThumbs.addEventListener('change', loadDesktopThumbs);
      // Smooth gallery (owner Oct 10: "its gray and then image loads... the video sort of flashes"). Photos past the
      // hero fade in over their blurred preview once loaded, and the next three slides are fetched ahead of the
      // swipe (after the page has loaded, so the hero keeps its head start). The video fades in on 'playing'.
      var saveData = !!(navigator.connection && navigator.connection.saveData);
      slides.forEach(function (slide) {
        if (slide.classList.contains('ov9-gallery__slide--hero')) return;
        $$('img.ov9-gallery__img', slide).forEach(function (img) {
          if (img.complete && img.naturalWidth) { slide.classList.add('is-loaded'); return; }
          img.classList.add('is-pending');
          var done = function () { img.classList.remove('is-pending'); slide.classList.add('is-loaded'); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
        var v = slide.hasAttribute('data-ov9-video') && $('video', slide);
        if (v) v.addEventListener('playing', function () {
          slide.classList.add('is-playing');
          // The speaker shows only when the video really has sound (decoders report it once it plays).
          setTimeout(function () {
            if ((v.audioTracks && v.audioTracks.length) || v.mozHasAudio || v.webkitAudioDecodedByteCount > 0) slide.classList.add('has-audio');
          }, 1200);
        }, { once: true });
      });
      var pageLoaded = document.readyState === 'complete';
      var warmFrom = 0;
      var warm = function (from) {
        warmFrom = Math.max(warmFrom, from);
        if (!pageLoaded) return;
        for (var k = warmFrom + 1; k <= warmFrom + 3 && k < slideCount; k++) {
          $$('img[loading="lazy"]', slides[k]).forEach(function (img) { img.loading = 'eager'; });
          var v = slides[k].hasAttribute('data-ov9-video') && $('video', slides[k]);
          if (v && !saveData && v.preload !== 'auto') v.preload = 'auto';
        }
      };
      if (!pageLoaded) window.addEventListener('load', function () { pageLoaded = true; setTimeout(function () { warm(warmFrom); }, 300); }, { once: true });
      else warm(0);
      // A finger on the photo means a swipe is coming: start the next slides now even if the page is still loading.
      track.addEventListener('pointerdown', function () { pageLoaded = true; warm(Math.round(track.scrollLeft / (track.clientWidth || 1))); }, { passive: true });
      var raf = 0;
      var followTimer = 0;
      var lastSlide = 0;
      var onScroll = function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (navTarget !== null && Math.abs(track.scrollLeft - navTarget * w) < 2) navTarget = null;
          if (count) count.textContent = String(i + 1);
          if (i !== lastSlide) {
            lastSlide = i;
            /* Which photo a shopper reached, for casa-gallery-events.js (GA4 + Clarity). */
            try { doc.dispatchEvent(new CustomEvent('casa:gallery:slide', { detail: { index: i + 1, total: slideCount, where: 'gallery' } })); } catch (e) { /* noop */ }
          }
          warm(i);
          gallery.classList.toggle('is-off-hero', i !== 0);
          gallery.classList.toggle('is-arrows-low', !!(slides[i] && slides[i].hasAttribute('data-ov9-arrows-low')));
          // The product video plays only while it is the slide in view.
          slides.forEach(function (slide, k) {
            var v = slide.hasAttribute('data-ov9-video') && $('video', slide);
            if (!v) return;
            if (k === i && !reduced.matches) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); v.muted = true; slide.classList.remove('is-sound'); }
          });
          thumbs.forEach(function (t) {
            if (parseInt(t.getAttribute('data-ov9-thumb'), 10) !== i) { t.removeAttribute('aria-current'); return; }
            t.setAttribute('aria-current', 'true');
            // Keep the active thumbnail in view (rail on desktop, strip on phones) once the photo has settled.
            // Instant and deferred: a smooth scroll here cancels the photo's own smooth scroll.
            clearTimeout(followTimer);
            followTimer = setTimeout(function () {
              var list = t.closest('.ov9-gallery__thumbs');
              if (!list) return;
              var lr = list.getBoundingClientRect();
              var tr = t.getBoundingClientRect();
              if (tr.left < lr.left) list.scrollLeft += tr.left - lr.left - 8;
              else if (tr.right > lr.right) list.scrollLeft += tr.right - lr.right + 8;
              if (tr.top < lr.top) list.scrollTop += tr.top - lr.top - 8;
              else if (tr.bottom > lr.bottom) list.scrollTop += tr.bottom - lr.bottom + 8;
            }, 180);
          });
          navs.forEach(function (b) {
            var step = parseInt(b.getAttribute('data-ov9-nav'), 10);
            b.setAttribute('aria-disabled', (step < 0 ? i <= 0 : i >= slideCount - 1) ? 'true' : 'false');
          });
        });
      };
      track.addEventListener('scroll', onScroll, { passive: true });
      // A swipe or wheel takes over from a pending arrow scroll.
      ['pointerdown', 'wheel'].forEach(function (type) {
        track.addEventListener(type, function () { navTarget = null; }, { passive: true });
      });
      gallery.addEventListener('click', function (e) {
        var nav = e.target.closest('[data-ov9-nav]');
        var t = e.target.closest('[data-ov9-thumb]');
        var w = track.clientWidth || 1;
        var i;
        if (nav) {
          var base = navTarget !== null && Date.now() - navAt < 700 ? navTarget : Math.round(track.scrollLeft / w);
          i = base + (parseInt(nav.getAttribute('data-ov9-nav'), 10) || 0);
          if (i < 0 || i > slideCount - 1) return;
          navTarget = i;
          navAt = Date.now();
        } else if (t) {
          i = parseInt(t.getAttribute('data-ov9-thumb'), 10) || 0;
          navTarget = null;
        } else {
          var tapped = e.target.closest('[data-ov9-slide]');
          if (!tapped || !track.contains(tapped)) return;
          var tv = tapped.hasAttribute('data-ov9-video') && $('video', tapped);
          if (tv && tapped.classList.contains('has-audio')) {
            // A video with sound stays in place (merchant, 2026-08-13): a tap turns its sound on or off.
            tv.muted = !tv.muted;
            tapped.classList.toggle('is-sound', !tv.muted);
            if (tv.paused) { var pp = tv.play(); if (pp && pp.catch) pp.catch(function () {}); }
            return;
          }
          // A photo, or a silent video, opens full screen: assets/casa-photo-viewer.js listens for that tap itself.
          return;
        }
        track.scrollTo({ left: i * w, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
    }

    var edd = $('[data-ov9-edd]', main);
    /* Outside the US the line already holds checkout's own delivery time (Liquid); the app's US dates are ignored. */
    if (edd && edd.hasAttribute('data-ov9-edd-fixed')) {
      var fixed = $('[data-ov9-edd-text] strong', edd);
      if (fixed) {
        $$('[data-ov9-ship-card]').forEach(function (card) {
          var d = $('[data-ov9-ship-date]', card);
          var line = $('[data-ov9-ship-arrive]', card);
          if (!d || !line) return;
          d.textContent = fixed.textContent;
          line.hidden = false;
        });
      }
    } else if (edd) {
      var tries = 0;
      var fill = function () {
        var input = $('[data-ov9-main] input[name="properties[Estimated delivery]"]');
        var val = input && input.value && input.value.trim();
        if (val) {
          var text = $('[data-ov9-edd-text]', edd);
          text.textContent = '';

          var strong = doc.createElement('strong');
          /* The app writes "Sep 30 - Oct 03": en dash for the range, no leading zero on the day ("Oct 3"). */
          strong.textContent = val.replace(/\s+-\s+/, '–').replace(/\b([A-Za-z]{3,}\.?\s+)0(\d)\b/g, '$1$2');
          text.appendChild(strong);
          var origin = $('[data-ov9-edd-origin]', edd);
          if (origin) origin.hidden = false;
          edd.classList.add('has-date');
          // Delivery panel date card (owner Oct 9): same estimate, second line of the card.
          $$('[data-ov9-ship-card]').forEach(function (card) {
            var d = $('[data-ov9-ship-date]', card);
            var line = $('[data-ov9-ship-arrive]', card);
            if (!d || !line) return;
            d.textContent = strong.textContent;
            line.hidden = false;
          });
          return;
        }
        if (++tries < 40) setTimeout(fill, 300);
      };
      fill();
    }
  }

  /* ---------------- Take it apart ---------------- */
  function initApart(sec) {
    if (!sec || sec.dataset.ov9Init) return;
    sec.dataset.ov9Init = '1';
    var pieces = $$('[data-ov9-piece]', sec);
    var marker = $('[data-ov9-marker]', sec);
    var steps = $$('[data-ov9-step]', sec);
    var total = steps.length + 1;
    var nextBtn = $('[data-ov9-step-next]', sec);
    var nextText = $('[data-ov9-next-text]', sec);
    var timers = [];
    var started = false;
    var step = 1;
    var phase = 'assembled';

    function parts(n) {
      var li = steps[n - 1];
      if (!li) return [];
      return (li.getAttribute('data-parts') || '').split(',').map(function (x) { return parseInt(x, 10) - 1; }).filter(function (x) { return x >= 0; });
    }
    function layout() {
      var on = phase === 'focus' && step < total ? parts(step) : [];
      var featuring = on.length > 0;
      pieces.forEach(function (img, k) {
        var u = (k - 3) / 3;
        var focus = on.indexOf(k) !== -1;
        var x, y, size, op = 1;
        if (phase === 'assembled') { x = 0; y = 0; size = 0.66; }
        else if (!featuring) { x = u * 0.2 + Math.sin(u * Math.PI) * 0.025; y = u * 0.18; size = 0.66; }
        else if (focus) { x = -0.13; y = 0.1; size = 0.88; }
        else { x = 0.12 + u * 0.17 + Math.sin(u * Math.PI) * 0.035; y = -0.13 + u * 0.17; size = 0.4; op = 0.72; }
        img.style.transform = 'translate(' + (x * 100).toFixed(2) + '%, ' + (y * 100).toFixed(2) + '%) scale(' + size.toFixed(4) + ')';
        img.style.opacity = String(op);
        img.style.zIndex = String((focus ? 100 : 0) + 7 - k);
      });
      if (marker) marker.textContent = featuring ? String(step) : '';
      sec.setAttribute('data-phase', phase);
      sec.setAttribute('data-featuring', featuring ? 'true' : 'false');
      sec.setAttribute('data-step', String(step));
      sec.classList.toggle('is-install', step === total);
      steps.forEach(function (li, i) { li.classList.toggle('is-active', i + 1 === step); });
      $$('.ov9-apart__tab', sec).forEach(function (t) {
        t.setAttribute('aria-pressed', parseInt(t.getAttribute('data-ov9-step-go'), 10) === step ? 'true' : 'false');
      });
      if (nextText && nextBtn) nextText.textContent = step === total ? nextBtn.getAttribute('data-replay-label') : nextBtn.getAttribute('data-next-label');
    }
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function go(n) { clear(); started = true; phase = 'focus'; step = Math.max(1, Math.min(total, n)); layout(); }
    function play() {
      clear();
      started = true;
      if (reduced.matches) { phase = 'focus'; step = 1; layout(); return; }
      phase = 'assembled'; step = 1; layout();
      timers.push(setTimeout(function () { phase = 'spread'; layout(); }, 700));
      timers.push(setTimeout(function () { phase = 'focus'; step = 1; layout(); }, 1700));
    }
    sec.addEventListener('click', function (e) {
      var g = e.target.closest('[data-ov9-step-go]');
      if (g) { go(parseInt(g.getAttribute('data-ov9-step-go'), 10)); return; }
      if (e.target.closest('[data-ov9-step-next]')) {
        if (step >= total) play(); else go(step + 1);
      }
    });
    if (reduced.matches) {
      phase = 'focus';
      $$('[data-ov9-install-svg] animateTransform', sec).forEach(function (a) { a.setAttribute('values', '0 0;0 0;0 0;0 0;0 0'); });
    }
    layout();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !started) { play(); io.disconnect(); }
        });
      }, { threshold: 0.35 });
      io.observe($('[data-ov9-stage]', sec) || sec);
    } else {
      go(1);
    }

    // The answers remain in document order. As a shopper reads down the list,
    // focus the matching physical part without taking over native scrolling.
    var scrollFrame = 0;
    function syncApartScroll() {
      scrollFrame = 0;
      if (phase !== 'focus') return;
      var bounds = sec.getBoundingClientRect();
      if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
      var guide = window.innerHeight * (window.innerWidth < 990 ? 0.65 : 0.55);
      var visibleStep = 1;
      steps.forEach(function (li, i) {
        if (li.getBoundingClientRect().top <= guide) visibleStep = i + 1;
      });
      var install = $('[data-ov9-step-panel]', sec);
      if (install && install.getBoundingClientRect().top <= guide) visibleStep = total;
      if (visibleStep !== step) { step = visibleStep; layout(); }
    }
    function scheduleApartScroll() {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(syncApartScroll);
    }
    window.addEventListener('scroll', scheduleApartScroll, { passive: true });
    window.addEventListener('resize', scheduleApartScroll);
  }

  /* ---------------- See it on your wall ---------------- */
  var FURN = { sofa: { w: 84, top: 44 }, bed: { w: 60, top: 60 }, console: { w: 48, top: 42 }, desk: { w: 55, top: 58 } };
  function oct(cx, cy, d) {
    var a = d / 2, b = a * 0.41421;
    return [[cx - b, cy - a], [cx + b, cy - a], [cx + a, cy - b], [cx + a, cy + b], [cx + b, cy + a], [cx - b, cy + a], [cx - a, cy + b], [cx - a, cy - b]]
      .map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
  }
  function wallDraw() {
    $$('[data-ov9-wall]').forEach(function (sec) {
      if (!api.current) return;
      var f = FURN[sec.getAttribute('data-furn')] || FURN.bed;
      var pick = $('[data-ov9-pick][data-variant-id="' + api.current.variantId + '"]', sec);
      var inch = pick ? parseFloat(pick.getAttribute('data-inch')) : 27.6;
      var k = 358 / 120, d = inch * k, bottom = 286 - f.top * k, cy = bottom - d / 2, cx = 200;
      var small = api.current.sizeKey === 's';
      $$('polygon[data-oct]', sec).forEach(function (p) {
        p.setAttribute('points', oct(cx, cy, d * parseInt(p.getAttribute('data-oct'), 10) / 100));
        var sw = p.getAttribute('data-sw');
        if (sw) p.setAttribute('stroke-width', sw === '1' ? (small ? 1.5 : 2.5) : (small ? 1 : 1.6));
      });
      var furnBtn = $('[data-ov9-furn][aria-checked="true"]', sec);
      var shortName = furnBtn ? furnBtn.textContent.trim().toLowerCase() : '';
      var pct = String(Math.round(inch / f.w * 100));
      $$('[data-ov9-pct]', sec).forEach(function (el) { el.textContent = pct; });
      $$('[data-ov9-furn-short]', sec).forEach(function (el) { el.textContent = shortName; });
      var svg = $('[data-ov9-wall-svg]', sec);
      var cap = $('[data-furn-text="' + sec.getAttribute('data-furn') + '"]', sec);
      var row = $('.ov9-wall__readout-row[data-ov9-for="' + api.current.sizeKey + '"] .ov9-wall__readout-main', sec);
      if (svg) svg.setAttribute('aria-label', (row ? row.textContent.trim() + '. ' : '') + (cap ? cap.textContent.trim() : ''));
    });
  }
  function initWall(sec) {
    if (!sec || sec.dataset.ov9Init) return;
    sec.dataset.ov9Init = '1';
    sec.addEventListener('click', function (e) {
      var f = e.target.closest('[data-ov9-furn]');
      if (f) { setFurn(sec, f); return; }
      var l = e.target.closest('[data-ov9-wall-lights]');
      if (l) {
        var state = l.getAttribute('data-ov9-wall-lights');
        sec.setAttribute('data-wall-lights', state);
        $$('[data-ov9-wall-lights]', sec).forEach(function (b) { b.setAttribute('aria-pressed', b === l ? 'true' : 'false'); });
      }
    });
    wallDraw();
  }
  function setFurn(sec, btn) {
    sec.setAttribute('data-furn', btn.getAttribute('data-ov9-furn'));
    $$('[data-ov9-furn]', sec).forEach(function (b) {
      var on = b === btn;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    wallDraw();
  }

  /* ---------------- buy bar ---------------- */
  var bar = null, barRaf = 0, barShown = false;
  function barUpdate() {
    barRaf = 0;
    if (!bar) return;
    var vh = window.innerHeight;
    // Theme sticky rules (casa-sticky-cart.js): show only once the shopper has scrolled
    // past the main buy button (desktop: past the whole product section), never on the
    // first screen, and hide again 200px before the footer and while any other in-page
    // add-to-cart button is on screen.
    // Phones (owner Oct 9, S1): the pill shows once the page's own price has scrolled off the first screen;
    // shown on load it covered the price on a 390x664 iPhone.
    var main = $('[data-ov9-main]');
    var mainPrice = main && $('.ov9-price', main);
    var gate = window.matchMedia('(min-width: 750px)').matches ? (main && (main.closest('.shopify-section') || main)) : mainPrice;
    var passed = !!gate && gate.getBoundingClientRect().bottom < 0;
    var footer = $('footer.casa-footer') || $('footer');
    var nearFooter = !!footer && footer.getBoundingClientRect().top < vh + 200;
    var otherAtc = $$('[data-ov9-atc]').some(function (b) {
      if (bar.contains(b)) return false;
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh;
    });
    var show = passed && !nearFooter && !otherAtc;
    if (show === barShown) return;
    barShown = show;
    bar.classList.toggle('is-shown', show);
    root.classList.toggle('ov9-bar-on', show);
    if (show) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
    else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); closeBarSizes(); }
  }
  function barSchedule() { if (!barRaf) barRaf = requestAnimationFrame(barUpdate); }

  // Phone pill fit (owner Oct 9, S1; mock state/handoffs/assets/v9-slim-bar-S1-mock.html in casa-ops): steps are
  // cumulative and stop as soon as everything fits. Name "Infinity OctaMirror" -> "OctaMirror" -> hidden, then a
  // smaller button, "L · 27.6″", a 34 px thumb, tighter gaps, then (280 px phones in long currencies) a wider pill and
  // no thumb. Words are never cut or ended in "…".
  var PILL_STEPS = 8;
  function pillOver(pill) {
    var meta = $('.ov9-pill__meta', pill), btn = $('.ov9-pill__btn', pill);
    if (!meta || !btn) return false;
    var pr = pill.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var need = 0;
    $$('.ov9-pill__name, .ov9-pill__label', meta).forEach(function (e) { if (e.getClientRects().length) need = Math.max(need, e.scrollWidth); });
    return br.right > pr.right - 3 || meta.clientWidth < need - 0.5 || btn.scrollWidth > btn.clientWidth + 1;
  }
  function fitPill() {
    var pill = bar && $('[data-ov9-pill]', bar);
    if (!pill || !pill.getClientRects().length) return;
    var fit = 0;
    pill.setAttribute('data-fit', '0');
    while (fit < PILL_STEPS && pillOver(pill)) pill.setAttribute('data-fit', String(++fit));
  }
  var pillRaf = 0;
  function schedulePill() { if (!pillRaf) pillRaf = requestAnimationFrame(function () { pillRaf = 0; fitPill(); }); }
  function closeBarSizes() {
    if (!bar) return;
    var s = $('[data-ov9-bar-sizes]', bar);
    $$('[data-ov9-bar-toggle]', bar).forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (s) s.hidden = true;
  }
  function initBar(el) {
    if (!el || el.dataset.ov9Init) return;
    el.dataset.ov9Init = '1';
    bar = el;
    bar.hidden = false;
    bar.setAttribute('inert', '');
    bar.setAttribute('aria-hidden', 'true');
    // The offer teaser must clear the whole bar, including its expanded size panel.
    // Publish only when height changes, avoiding document-wide writes on every scroll.
    var lastHeight = -1;
    var publishHeight = function () {
      var height = Math.ceil(el.getBoundingClientRect().height);
      if (height === lastHeight) return;
      lastHeight = height;
      root.style.setProperty('--ov9-bar-height', height + 'px');
    };
    publishHeight();
    if (window.ResizeObserver) {
      el.__ov9SizeObserver = new ResizeObserver(publishHeight);
      el.__ov9SizeObserver.observe(el);
    }
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ov9-bar-toggle]');
      if (t) {
        var s = $('[data-ov9-bar-sizes]', bar);
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        s.hidden = !open;
        if (open) { var c = $('[aria-checked="true"]', s); if (c) c.focus(); }
        return;
      }
      if (e.target.closest('[data-ov9-bar-close]')) {
        closeBarSizes();
        var tg = $$('[data-ov9-bar-toggle]', bar).filter(function (b) { return b.getClientRects().length; })[0];
        if (tg) tg.focus();
      }
    });
    bar.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBarSizes(); });
    if (!api.barBound) {
      api.barBound = true;
      window.addEventListener('scroll', barSchedule, { passive: true });
      window.addEventListener('resize', barSchedule, { passive: true });
      window.addEventListener('resize', schedulePill, { passive: true });
      doc.addEventListener('casa:octa-v9:size', schedulePill);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(schedulePill);
    }
    schedulePill();
    barSchedule();
  }

  /* ---------------- shared wiring ---------------- */
  doc.addEventListener('click', function (e) {
    var p = e.target.closest('[data-ov9-pick], [data-ov9-pick-only]');
    if (p) { select(p.getAttribute('data-variant-id')); return; }
    var a = e.target.closest('[data-ov9-atc]');
    if (a) addToCart(a);
  });
  doc.addEventListener('keydown', function (e) {
    var group = e.target.closest && e.target.closest('[data-ov9-radiogroup], [data-ov9-furn-group]');
    if (!group || ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
    var items = $$('[role="radio"]', group);
    var i = items.indexOf(e.target.closest('[role="radio"]'));
    if (i < 0) return;
    e.preventDefault();
    var n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
    n.focus();
    n.click();
  });
  doc.addEventListener('casa:octa-v9:select', function (e) {
    if (e.detail && e.detail.variantId) select(e.detail.variantId);
  });
  // Lower "Three sizes" strip (sections/casa-sizing.liquid) <-> buy box and buy bar, without waiting for
  // Horizon's page refetch (1-2 s, longer on phones). Before this, a tap on the strip lit LARGE there
  // while the buy bar still read Small $299.99 until variant:update landed, and the reverse for taps up top.
  // Strip -> V9: the strip writes the native radio and fires a bubbling 'change' (pushToPicker).
  doc.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.type !== 'radio' || !r.checked || !r.closest || !r.closest('[data-ov9-main] variant-picker')) return;
    var id = r.getAttribute('data-variant-id');
    if (id && byId(id) && (!api.current || String(api.current.variantId) !== String(id))) select(id, { fromNative: true });
  });
  // V9 -> strip: the native radio is already on this size, so the strip's own chip handler only repaints
  // (its pushToPicker returns early on a checked radio). .click() on a button moves neither focus nor scroll.
  doc.addEventListener('casa:octa-v9:size', function (e) {
    var k = e.detail && e.detail.sizeKey ? String(e.detail.sizeKey).toUpperCase() : '';
    var chip = k && $('.casa-sz__chip[data-casa-sz-chip="' + k + '"]');
    if (chip && !chip.classList.contains('is-on')) chip.click();
  });
  doc.addEventListener('variant:update', function (e) {
    var res = e.detail && e.detail.resource;
    if (res && res.id && byId(res.id) && api.current && String(res.id) !== String(api.current.variantId)) {
      var r = nativeRadio(res.id);
      if (r && r.checked) select(res.id, { fromNative: true });
    }
  });

  /* ---------------- Owner reviews: count, buttons, dots ---------------- */
  function initQuotes(rootEl) {
    if (!rootEl || rootEl.dataset.ov9Init) return;
    rootEl.dataset.ov9Init = '1';
    var track = $('[data-ov9-quotes-track]', rootEl);
    var items = track ? $$('.ov9-quotes__item', track) : [];
    if (items.length < 2) return;
    var index = $('[data-ov9-quotes-index]', rootEl);
    var dots = $$('[data-ov9-quotes-dot]', rootEl);
    var steps = $$('[data-ov9-quotes-step]', rootEl);
    var left = function (i) { return items[i].offsetLeft - items[0].offsetLeft; };
    var current = function () {
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return items.length - 1;
      var best = 0;
      items.forEach(function (it, i) { if (Math.abs(left(i) - track.scrollLeft) < Math.abs(left(best) - track.scrollLeft)) best = i; });
      return best;
    };
    var paint = function () {
      var i = current();
      if (index) index.textContent = String(i + 1);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      steps.forEach(function (b) {
        var s = parseInt(b.getAttribute('data-ov9-quotes-step'), 10);
        b.setAttribute('aria-disabled', (s < 0 ? i <= 0 : i >= items.length - 1) ? 'true' : 'false');
      });
    };
    var frame = 0;
    track.addEventListener('scroll', function () {
      if (!frame) frame = requestAnimationFrame(function () { frame = 0; paint(); });
    }, { passive: true });
    rootEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ov9-quotes-step]');
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      var i = Math.max(0, Math.min(items.length - 1, current() + parseInt(b.getAttribute('data-ov9-quotes-step'), 10)));
      track.scrollTo({ left: left(i), behavior: reduced.matches ? 'auto' : 'smooth' });
    });
    paint();
  }

  /* ---------------- Gift details ----------------
     Server-rendered market price and real gift reference. Opening details never
     selects a size; only the explicit action uses the existing selection API. */
  var giftDialog = null;
  var giftOpener = null;
  var giftInert = [];
  function closeGift() {
    if (!giftDialog) return;
    giftDialog.remove();
    giftDialog = null;
    root.classList.remove('ov9-gift-lock');
    giftInert.forEach(function (entry) { entry.node.inert = entry.inert; });
    giftInert = [];
    var opener = giftOpener;
    giftOpener = null;
    if (!opener || !opener.isConnected || !opener.getClientRects().length) {
      opener = $$('[data-ov9-gift-open]').find(function (button) { return button.getClientRects().length; });
    }
    if (opener) opener.focus();
  }
  function openGift(button) {
    var template = doc.getElementById(button.getAttribute('data-ov9-gift-open'));
    if (!template || !template.content) return;
    closeGift();
    giftOpener = button;
    giftDialog = template.content.firstElementChild.cloneNode(true);
    var action = $('[data-ov9-gift-select]', giftDialog);
    var included = api.current && api.current.sizeKey === giftDialog.getAttribute('data-gift-size');
    action.textContent = action.getAttribute(included ? 'data-included-label' : 'data-label');
    action.setAttribute('data-included', included ? 'true' : 'false');
    Array.prototype.forEach.call(doc.body.children, function (node) {
      giftInert.push({ node: node, inert: node.inert });
      node.inert = true;
    });
    doc.body.appendChild(giftDialog);
    root.classList.add('ov9-gift-lock');
    $('[data-ov9-gift-close]', giftDialog).focus();
  }
  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ov9-gift-open]');
    if (opener) { openGift(opener); return; }
    if (!giftDialog) return;
    if (e.target === giftDialog || e.target.closest('[data-ov9-gift-close]')) { closeGift(); return; }
    var action = e.target.closest('[data-ov9-gift-select]');
    if (action && giftDialog.contains(action)) {
      if (action.getAttribute('data-included') !== 'true') { select(action.getAttribute('data-variant-id')); closeGift(); return; }
      /* Oct 12, Elie ("Change it"): the qualifying size is already chosen, so the button is an action:
         it uses the page's own add-to-cart path (native form click), so the native free gift adds the Orb. */
      closeGift();
      addToCart(action);
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (!giftDialog) return;
    if (e.key === 'Escape') { e.preventDefault(); closeGift(); }
    else if (e.key === 'Tab') {
      var controls = $$('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]', giftDialog);
      var first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Photo viewer (review photos) ----------------
     A fixed <div>, never <dialog> (iOS Safari paint bugs). Closes on the X, a backdrop tap or
     Escape; focus moves to the X and returns to the photo that opened it. */
  var zoom = null;
  var zoomOpener = null;
  function closeZoom() {
    if (!zoom || !zoom.classList.contains('is-open')) return;
    zoom.classList.remove('is-open');
    root.classList.remove('ov9-zoom-lock');
    if (zoomOpener && zoomOpener.focus) zoomOpener.focus();
    zoomOpener = null;
  }
  function openZoom(btn) {
    if (!zoom) {
      zoom = doc.createElement('div');
      zoom.className = 'ov9-zoom';
      zoom.setAttribute('role', 'dialog');
      zoom.setAttribute('aria-modal', 'true');
      var close = doc.createElement('button');
      close.type = 'button';
      close.className = 'ov9-zoom__close';
      close.setAttribute('aria-label', 'Close photo');
      close.textContent = '×';
      var fig = doc.createElement('figure');
      fig.className = 'ov9-zoom__figure';
      var img = doc.createElement('img');
      img.className = 'ov9-zoom__img';
      var cap = doc.createElement('figcaption');
      cap.className = 'ov9-zoom__caption';
      fig.appendChild(img);
      fig.appendChild(cap);
      zoom.appendChild(close);
      zoom.appendChild(fig);
      doc.body.appendChild(zoom);
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom || e.target.closest('.ov9-zoom__close')) closeZoom();
      });
    }
    var image = $('.ov9-zoom__img', zoom);
    image.src = btn.getAttribute('data-ov9-zoom-src');
    image.alt = btn.getAttribute('data-ov9-zoom-alt') || '';
    $('.ov9-zoom__caption', zoom).textContent = btn.getAttribute('data-ov9-zoom-caption') || '';
    zoom.setAttribute('aria-label', image.alt || 'Photo');
    zoomOpener = btn;
    root.classList.add('ov9-zoom-lock');
    zoom.classList.add('is-open');
    $('.ov9-zoom__close', zoom).focus();
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ov9-zoom-src]');
    if (b) openZoom(b);
  });
  doc.addEventListener('keydown', function (e) {
    if (!zoom || !zoom.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeZoom(); }
    else if (e.key === 'Tab') { e.preventDefault(); $('.ov9-zoom__close', zoom).focus(); } // one control: keep focus inside
  });

  // Desktop proof under the gallery (owner Oct 6: "sure do it" to venue logos there), moved from the end of the
  // buy column.
  function initProof(main) {
    if (main && $('[data-ov9-stories]', main)) return;
    if (!main || main.__ov9Proof) return;
    var media = $('.product-information__media', main);
    var gallery = media && $('.ov9-gallery', media);
    var venues = $('.ov9-assure__venues--desktop', main);
    if (!gallery || !venues) return;
    main.__ov9Proof = true;
    var shell = doc.createElement('div');
    shell.className = 'ov9-proof-wrap';
    var proof = doc.createElement('div');
    proof.className = 'ov9-proof';
    shell.appendChild(proof);
    // Owner Oct 10: "review images cant duiplicate themselves under gallery and under add to cart too". The owner
    // photos stay only in the review cards under Add to cart; under the gallery only the venue logos remain.
    proof.appendChild(venues);
    gallery.insertAdjacentElement('afterend', shell);
    main.classList.add('ov9-has-proof');
    // The photo column stays sticky; when it is taller than the window, it sticks with its bottom in
    // view, so the photo keeps its size and the proof shows as soon as the shopper scrolls.
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { main.style.setProperty('--ov9-media-h', media.offsetHeight + 'px'); }).observe(media);
    }
  }

  // Owner Oct 20 (Tri desktop): "as you scroll on trimirror page these logos cover the image". On pages with no
  // owner videos the venue logos sat in a third grid row under the sticky photo column, and a sticky item can
  // travel to the end of its whole grid, so the photos slid over the logos. Owner Oct 20, after release 3: "logos
  // shouldve appeared below desktop gallery, not as a section below on page". On desktop the logos now move into
  // the photo column, straight under the gallery, so photos and logos stay in view together and never overlap.
  // Phones keep them in place.
  function initStoriesOut(main) {
    var grid = main && $('.product-information__grid', main);
    var stories = grid && $('.ov9-stories', main);
    var media = grid && $('.product-information__media', grid);
    var gallery = media && $('.ov9-gallery', media);
    if (!stories || !gallery || $('.casa-vtm', stories) || main.__ov9StoriesOut) return;
    main.__ov9StoriesOut = true;
    var mq = window.matchMedia('(min-width: 990px)');
    function place() {
      if (mq.matches && stories.parentNode === grid) {
        gallery.insertAdjacentElement('afterend', stories);
        main.classList.add('ov9-stories-in');
      }
      else if (!mq.matches && stories.parentNode !== grid) { grid.appendChild(stories); main.classList.remove('ov9-stories-in'); }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    // When photos plus logos are taller than the window, the column sticks with its bottom in view.
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { main.style.setProperty('--ov9-media-h', media.offsetHeight + 'px'); }).observe(media);
    }
  }

  function initAll() {
    var json = $('script[data-ov9-variants]');
    if (json && !variants.length) { try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; } }
    if (!variants.length) return;
    initMain($('[data-ov9-main]'));
    initProof($(".ov9-main"));
    initStoriesOut($(".ov9-main"));
    $$('[data-ov9-apart]').forEach(initApart);
    $$('[data-ov9-wall]').forEach(initWall);
    $$('[data-ov9-quotes]').forEach(initQuotes);
    initBar($('[data-ov9-bar]'));
    if (!api.current) {
      var start = byKey(root.dataset.octaV9Size) || variants[0];
      var checked = $('[data-ov9-main] variant-picker input[type="radio"]:checked');
      if (checked && byId(checked.getAttribute('data-variant-id'))) start = byId(checked.getAttribute('data-variant-id'));
      select(start.id, { fromNative: true, force: true });
    } else {
      paintPickers(api.current.variantId);
      wallDraw();
      paintAvailability();
    }
    barSchedule();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  doc.addEventListener('shopify:section:load', initAll);
  doc.addEventListener('shopify:section:unload', function (e) {
    if (giftDialog && giftOpener && e.target && e.target.contains(giftOpener)) closeGift();
    if (bar && e.target && e.target.contains(bar)) {
      if (bar.__ov9SizeObserver) bar.__ov9SizeObserver.disconnect();
      root.style.removeProperty('--ov9-bar-height');
      root.classList.remove('ov9-bar-on');
      barShown = false;
      bar = null;
    }
  });
})();
